/* CyperGlow-style landing behaviours */
(function () {
  if (window.__cgInit) return; window.__cgInit = true;
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
    return (fmt || '€{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v).replace(/<[^>]+>/g, '').trim();
  };

  /* gallery */
  document.querySelectorAll('[data-cg-gallery]').forEach((g) => {
    const slides = [...g.querySelectorAll('.cg-gallery__slide')], thumbs = [...g.querySelectorAll('.cg-gallery__thumb')];
    let i = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    const show = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-active', k === i)); thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' }); };
    g.querySelector('.cg-gallery__nav--prev')?.addEventListener('click', () => show(i - 1));
    g.querySelector('.cg-gallery__nav--next')?.addEventListener('click', () => show(i + 1));
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    let x0 = null;
    g.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    g.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1); x0 = null; });
  });

  /* bundles */
  document.querySelectorAll('[data-cg-bundles]').forEach((wrap) => {
    const form = document.getElementById(wrap.dataset.form), idInput = form?.querySelector('input[name="id"]');
    const saving = document.querySelector('[data-cg-saving]'), savingAmt = saving?.querySelector('[data-cg-saving-amount]');
    const fmt = wrap.dataset.moneyFormat;
    const update = (label) => {
      wrap.querySelectorAll('.cg-bundle').forEach((b) => b.classList.toggle('is-selected', b === label));
      const gift = +label.dataset.gift || 0, qtyInput = form?.querySelector('input[name="quantity"]');
      const f = (k) => form?.querySelector('[data-cg-' + k + ']');
      if (label.dataset.addId) {
        /* n Einzelflaschen + Gratis-Flaschen; den Paketpreis rechnet Shopify über automatische Rabatte */
        const n = +label.dataset.addQty || 1, mitGratis = gift > 0;
        if (idInput) { idInput.value = label.dataset.addId; idInput.disabled = mitGratis; }
        if (qtyInput) { qtyInput.value = n; qtyInput.disabled = mitGratis; }
        [['i0', label.dataset.addId], ['q0', n], ['i1', label.dataset.giftId], ['q1', gift]].forEach(([k, v]) => { const el = f(k); if (el) { el.value = v; el.disabled = !mitGratis; } });
      } else if (idInput && label.dataset.variantId !== '0') idInput.value = label.dataset.variantId;
      const price = +label.dataset.price, compare = +label.dataset.compare;
      if (saving) { if (compare > price) { savingAmt.textContent = money(compare - price, fmt); saving.hidden = false; } else saving.hidden = true; }
      if (label.dataset.variantId !== '0') { const url = new URL(location.href); url.searchParams.set('variant', label.dataset.variantId); history.replaceState({}, '', url); }
    };
    wrap.querySelectorAll('.cg-bundle').forEach((label) => label.querySelector('input')?.addEventListener('change', () => update(label)));
    const sel = wrap.querySelector('.cg-bundle input:checked')?.closest('.cg-bundle') || wrap.querySelector('.cg-bundle');
    if (sel) update(sel);
  });


  /* count-up */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target, target = +el.dataset.count, suffix = el.dataset.suffix || '', t0 = performance.now(), dur = 1800;
      const tick = (t) => { const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(target * e) + suffix; if (p < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick); io.unobserve(el);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-count]').forEach((el) => io.observe(el));

  /* roadmap steps */
  const steps = document.querySelectorAll('.cg-step');
  if (steps.length) {
    const so = new IntersectionObserver((entries) => entries.forEach((en) => en.target.classList.toggle('is-active', en.isIntersecting)), { rootMargin: '-15% 0px -25% 0px' });
    steps.forEach((s) => so.observe(s)); steps[0].classList.add('is-active');
  }

  /* tabs */
  document.querySelectorAll('[data-cg-tabs]').forEach((t) => {
    const tabs = [...t.querySelectorAll('.cg-tab')], panes = [...t.querySelectorAll('.cg-tabpane')], bg = t.querySelector('.cg-tabs__bg');
    const place = (tab) => { if (!bg) return; bg.style.width = tab.offsetWidth + 'px'; bg.style.transform = `translateX(${tab.offsetLeft}px)`; };
    tabs.forEach((tab, k) => tab.addEventListener('click', () => {
      tabs.forEach((x, j) => x.classList.toggle('is-active', j === k)); panes.forEach((x, j) => x.classList.toggle('is-active', j === k)); place(tab);
    }));
    const init = () => { const a = tabs.find((x) => x.classList.contains('is-active')) || tabs[0]; if (a) place(a); };
    init(); window.addEventListener('resize', init); if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
  });

  /* before/after */
  document.querySelectorAll('.cg-ba').forEach((ba) => {
    const set = (x) => { const r = ba.getBoundingClientRect(); ba.style.setProperty('--split', Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100)) + '%'); };
    let drag = false;
    ba.addEventListener('pointerdown', (e) => { drag = true; ba.setPointerCapture(e.pointerId); set(e.clientX); });
    ba.addEventListener('pointermove', (e) => drag && set(e.clientX));
    ['pointerup', 'pointercancel'].forEach((ev) => ba.addEventListener(ev, () => (drag = false)));
  });

  /* generic scroll sliders (ingredients, feature) with arrows + pager */
  document.querySelectorAll('[data-cg-scroller]').forEach((s) => {
    const track = s.querySelector('[data-cg-track]'), prev = s.querySelector('[data-cg-prev]'), next = s.querySelector('[data-cg-next]');
    const cur = s.querySelector('[data-cg-cur]'), tot = s.querySelector('[data-cg-tot]');
    const items = [...track.children]; if (!items.length) return;
    const step = () => items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    const perView = () => Math.max(1, Math.round(track.clientWidth / step()));
    const pages = () => Math.max(1, Math.ceil(items.length / perView()));
    const page = () => Math.min(pages() - 1, Math.round(track.scrollLeft / (step() * perView())));
    const render = () => { if (cur) cur.textContent = page() + 1; if (tot) tot.textContent = pages(); if (prev) prev.disabled = track.scrollLeft <= 2; if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step() * perView(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step() * perView(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(render)); window.addEventListener('resize', render); render();
  });

  /* reviews carousel (translate, looping) */
  document.querySelectorAll('[data-cg-carousel]').forEach((c) => {
    const track = c.querySelector('.cg-reviews__track, .cg-carousel-track'), cards = [...track.children], n = cards.length; if (!n) return;
    const dotsWrap = c.querySelector('.cg-dots'); let idx = 0;
    const gap = 20, w = () => cards[0].getBoundingClientRect().width + gap;
    const dots = cards.map((_, k) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Bewertung ' + (k + 1)); b.addEventListener('click', () => go(k)); dotsWrap?.appendChild(b); return b; });
    const go = (k) => { idx = (k + n) % n; const center = (c.clientWidth - cards[0].getBoundingClientRect().width) / 2; track.style.transform = `translateX(${center - idx * w()}px)`; dots.forEach((d, j) => d.classList.toggle('is-active', j === idx)); };
    c.querySelector('[data-cg-prev]')?.addEventListener('click', () => go(idx - 1));
    c.querySelector('[data-cg-next]')?.addEventListener('click', () => go(idx + 1));
    window.addEventListener('resize', () => go(idx)); go(Math.min(1, n - 1));
    let x0 = null;
    track.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    track.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1); x0 = null; });
  });

  /* testimonial slider */
  document.querySelectorAll('[data-cg-testi]').forEach((sl) => {
    const track = sl.querySelector('.cg-testi-track'), slides = [...track.children]; if (slides.length < 2) { sl.querySelectorAll('.cg-testi-nav').forEach((b) => (b.style.display = 'none')); return; }
    let i = 0; const go = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s) => (s.style.transform = `translateX(-${i * 100}%)`)); };
    sl.querySelector('[data-cg-prev]').addEventListener('click', () => go(i - 1)); sl.querySelector('[data-cg-next]').addEventListener('click', () => go(i + 1));
    let x0 = null; track.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    track.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null; });
  });

  /* CTA scroll */
  document.querySelectorAll('[data-cg-scroll-to]').forEach((b) => b.addEventListener('click', (e) => { const t = document.querySelector(b.dataset.cgScrollTo); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }));
})();
